export const isEmail = (value: string): boolean => {
    if (value === null) {
        return false;
    }
    let reg = (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i);
    return reg.test(value.toLowerCase());
};

export const minLength = (value: string, min: number): boolean => {
    return value.length >= min;
};

export const maxLength = (value: string, max: number): boolean => {
    return value.length <= max;
};
